export default __webpack_public_path__ + "static/media/navigation-Header-HD.58ec179d.jpg";